exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-header[data-v-39a7a33b]{position:-webkit-sticky;position:sticky;top:0;margin-top:20px;margin-bottom:10px;z-index:1}.list_item[data-v-39a7a33b]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:7px}.list_item .parent[data-v-39a7a33b]{height:30px;line-height:30px;text-align:center;background-color:#f5f5f5}.list_item .label[data-v-39a7a33b]{width:250px;text-align:right;line-height:35px}.list_item .remark[data-v-39a7a33b]{padding:0 20px;width:30%}\n", ""]);

// exports
